export class ChatThread {
    constructor(model, messages) {
        var _a, _b;
        this.id = model.id;
        this.title = model.title;
        this.workspaceId = model.workspaceId;
        this.userId = model.userId;
        this.createdAt = (_a = model.createdAt) !== null && _a !== void 0 ? _a : new Date(model.createdAt);
        this.updatedAt = (_b = model.updatedAt) !== null && _b !== void 0 ? _b : new Date(model.updatedAt);
        this.messages = messages !== null && messages !== void 0 ? messages : undefined;
    }
    copyWithMessages(messages) {
        return new ChatThread({
            id: this.id,
            title: this.title,
            workspaceId: this.workspaceId,
            userId: this.userId,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
        }, messages);
    }
    toRemote() {
        return {
            id: this.id,
            title: this.title,
            workspaceId: this.workspaceId,
            userId: this.userId,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
        };
    }
}
